import { createFeature, createReducer, on } from '@ngrx/store';
import { SettingsBase } from '../../../../shared/services/settings/settings.service';
import { settingsBaseActions } from './settings-base.actions';

export const SETTINGS_BASE_FEATURE_KEY = 'settingsBase';

export type SettingsBaseStatus = 'idle' | 'loading' | 'loaded' | 'error';
export type SettingsBaseMutationStatus = 'idle' | 'pending';

export interface SettingsBaseState {
  settings: SettingsBase | null;
  status: SettingsBaseStatus;
  mutationStatus: SettingsBaseMutationStatus;
  error: string | null;
}

export const initialSettingsBaseState: SettingsBaseState = {
  settings: null,
  status: 'idle',
  mutationStatus: 'idle',
  error: null,
};

export const settingsBaseReducer = createReducer(
  initialSettingsBaseState,
  on(settingsBaseActions.loadSettingsBase, state => ({
    ...state,
    status: 'loading',
    error: null,
  })),
  on(settingsBaseActions.loadSettingsBaseSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsBaseActions.loadSettingsBaseFailure, (state, { error }) => ({
    ...state,
    status: 'error',
    mutationStatus: 'idle',
    error,
  })),
  on(settingsBaseActions.updateSettingsBase, state => ({
    ...state,
    mutationStatus: 'pending',
    error: null,
  })),
  on(settingsBaseActions.updateSettingsBaseSuccess, (state, { settings }) => ({
    ...state,
    settings,
    status: 'loaded',
    mutationStatus: 'idle',
    error: null,
  })),
  on(settingsBaseActions.updateSettingsBaseFailure, (state, { error }) => ({
    ...state,
    mutationStatus: 'idle',
    error,
  })),
);

export const settingsBaseFeature = createFeature({
  name: SETTINGS_BASE_FEATURE_KEY,
  reducer: settingsBaseReducer,
});
